<template>
    <div class="upload-button">
        <div v-if="!downloadFile">
            <input @change="uploadFile" type="file" ref="file" style="display: none;" />
            <a href="" @click.prevent="$refs.file.click()"
               :class="{isLoading:loading}"
               class="outline button small txt green-secondary">
                <div class="msg">
                    <span class="material-icons">{{icon}}</span>
                    <b>{{ title }}</b>
                </div>
                <div style="margin-top:-29px;" class="loader green-secondary"></div>

            </a>
        </div>
        <div v-else style="position: relative;">
            <a target="_blank" :href="downloadFile" class="outline button small txt green-secondary">
                <span class="material-icons">{{downloadIcon}} </span>
                {{ downloadTitle }}
            </a>
            <a href @click.prevent="replaceFile" v-if="editable"
               style="margin-left: 5px; background: white; position: absolute; z-index: 9; top:-5px; right:-10px;">
                <span style="font-size: 15px;" class="material-icons">cancel</span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        created: function () {
            this.downloadFile = this.download
        },
        data:function() {
            return {
                loading:false,
                downloadFile:false
            }
        },
        props:{
            title:{ type:String, default:'Upload' },
            icon:{type:String, default: 'file_upload'},
            name:{type:String, default:'document'},
            download:{type:String},
            downloadTitle:{type:String,default:'Download'},
            downloadIcon:{type:String,default:'description'},
            editable:{type:Boolean, default:false}
        },
        methods: {
            uploadFile(e) {
                this.loading = true
                let formData = new FormData()
                const uploader = this
                formData.append('file',e.target.files[0])
                formData.append('type',this.name)
                $.ajax({
                    url: "/media",
                    data: formData,
                    cache: false,
                    contentType: false,
                    processData: false,
                    type: "POST",
                    success: function (data) {
                        uploader.loading = false
                        uploader.downloadFile = data
                    },
                    error: function(data) {
                        alert('An error occured')
                        uploader.loading = false
                    }
                });
            },
            replaceFile() {
                this.downloadFile = false
            }
        },
        mounted:function() {
        }
    }
</script>
